import { extract } from '../extractors/socialMomentum';

export function buildPromptBlock(project, a) {
  const d = extract(project, a);
  if (!d) return '';
  const lines = ['【社交热度（CoinGecko）】'];
  if (d.twitterFollowers != null)    lines.push(`Twitter 粉丝: ${d.twitterFollowers.toLocaleString()}`);
  if (d.telegramSubscribers)         lines.push(`Telegram 订阅: ${d.telegramSubscribers.toLocaleString()}`);
  if (d.redditSubscribers)           lines.push(`Reddit 订阅: ${d.redditSubscribers.toLocaleString()}`);
  if (d.watchlistUsers != null)      lines.push(`CG Watchlist 用户: ${d.watchlistUsers.toLocaleString()}`);
  if (d.bullishSentimentPct != null) lines.push(`社区看涨情绪: ${Math.round(d.bullishSentimentPct)}%`);
  return lines.join('\n');
}
